import LandscapeScreen from "./LandscapeScreen";

export default LandscapeScreen;
